import React, { useEffect, useState } from 'react';
import { getMyPurchasedProducts } from 'common/utils/helper';
import './MyProduct.css';
import styled from 'styled-components';
import StartVcoin from '../../assets/images/StartVcoin.png'

const Wrapper = styled.div`
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;    
  margin:40px auto;   
  @media (max-width: 767px) {
    margin:0px auto;   
  }
`;

const SideText = styled.div`
  p{
  padding:5px 0px;
  }
  position: relative;
`;

const Box = styled.div`  
  border-radius: 10px;
  padding: ${window.screen.width > 767 ? "" : "1rem"};  
  overflow: hidden;
  width: 100%;
  height: 250px;
  @media (max-width: 767px) {
    height: auto;
  }
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000; /* optional background to show padding gap */
  
  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    border: 2px solid #fff; /* ✅ border directly on the image */
    border-radius: 10px;
  }
`;

const Title = styled.span`
  color: #FFD700;
  font-size:${window.screen.width > 767 ?"16px":"16px"};
  font-weight:100;  
`;

const ProductsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  width: 100%;
  margin: 0 auto;
  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
`;

const ProductCard = styled.div`
  background: #181818;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.18);
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  transition: box-shadow 0.2s;
  min-height: 180px;
  width: 100%;
  border: 1px solid #fff;
  @media (max-width: 767px) {
    flex-direction: row;
    min-height: 140px;
    width: 95vw;
    max-width: 95vw;
  }
  &:hover {
    box-shadow: 0 8px 32px rgba(0,0,0,0.28);
  }
`;

const VCoinStar = styled.div`
  position: absolute;
  bottom: ${window.screen.width > 767 ? "55px" : "40px"};
  right: 1px;
  width: 140px;
  height: 48px;
  display: flex;
  align-items: center;
  z-index: 2;

  .vcoin-pill {
    background: linear-gradient(90deg, #a020f0 60%, #d291ff 100%);
    border-radius: 40px;
    min-width: 110px;
    height: 36px;
    display: flex;
    align-items: center;
    padding: 0 1.2em 0 1.2em;
    box-shadow: 0 2px 12px rgba(160,32,240,0.18);
    position: relative;
    z-index: 1;
  }
  .vcoin-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    z-index: 2;
    margin-right: 10px;
    margin-left: 10px;
  }
  .vcoin-amount {
    color: #fff;
    font-weight: 900;
    font-size: 1em;
    text-shadow: 0 0 8px #FFD700, 0 1px 6px #000;
    letter-spacing: 0.5px;
    margin-bottom: 2px;
    pointer-events: none;
    line-height: 1;
  }
  .vcoin-label {
    color: #fff;
    font-size: 0.85em;
    font-weight: 600;
    text-shadow: 0 0 6px #FFD700, 0 1px 4px #000;
    letter-spacing: 0.2px;
    pointer-events: none;
    line-height: 1;
  }
  .gold-star {
    position: absolute;
    right: 23px;
    top: 50%;
    transform: translateY(-50%);
    width: 48px;
    height: 48px;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }
`;

const ProductImageWrapper = styled.div`
  flex: 1 1 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: #222;
  padding: 2.2rem;
  @media (max-width: 767px) {
    padding: 1.2rem;
    min-width: 100%;
    max-width: 100%;
  }
`;

const ProductImage = styled.img`
  max-width: 100%;
  max-height: 240px;
  object-fit: contain;
  border-radius: 10px;
  border: 2px solid #fff;
  background: #111;
  @media (max-width: 767px) {
    max-height: 160px;
  }
`;

const ProductInfo = styled.div`
  flex: 1 1 50%;
  padding: 1.2rem 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (max-width: 767px) {
    padding: 0.7rem 1.5rem;
    min-width: 50%;
    max-width: 50%;
  }
`;

const ProductName = styled.p`
  font-size: 0.98rem;
  font-weight: 500;
  color: #FFD700;
  margin-bottom: 0.3rem;
  @media (max-width: 767px) {
    font-size: 0.92rem;
  }
`;

const ProductDetail = styled.p`
  font-size: 0.85rem;
  color: #fff;
  margin-bottom: 0.18rem;
  span {
    color: #FFD700;
    font-weight: 400;
    font-size: 0.92em;
  }
  @media (max-width: 767px) {
    font-size: 0.78rem;
  }
`;

interface Product {
  userId: string;
  productId: number;
  productName?: string;
  priceUsd?: number;
  productSerialNumber?: string;
  rarity?: string;
  productStatus?: string;
  productPurchaseDate? : {
    _seconds: number;
    _nanoseconds: number;
  };
  productPurchaseAmount?: number;
  vCoin?: number;
  image_link?: string;
  // Add other fields if needed
}

const PurpleBadgeWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-bottom: 2rem;
`;

const PurplePill = styled.div`
  background: linear-gradient(90deg, #a020f0 60%, #d291ff 100%);
  color: #fff;
  border-radius: 40px;
  padding: 0.7em 2.8em 0.7em 1.5em;
  font-size: 1.25em;
  font-weight: 600;
  min-width: 160px;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 12px rgba(160,32,240,0.18);
`;

const GoldStar = styled.div`
  position: absolute;
  right: -32px;
  top: 50%;
  transform: translateY(-50%);
  width: 64px;
  height: 64px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
`;

function PurpleBadgeWithStar({ text }: { text: string }) {
  return (
    <PurpleBadgeWrapper>
      <PurplePill>{text}</PurplePill>
      <GoldStar>
        <svg viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
          <polygon points="25,2 31,18 48,18 34,29 39,46 25,36 11,46 16,29 2,18 19,18" fill="#FFD700" stroke="#fff" strokeWidth="2"/>
          <circle cx="25" cy="20" r="6" fill="#fff59d" fillOpacity="0.7"/>
        </svg>
      </GoldStar>
    </PurpleBadgeWrapper>
  );
}

function MyProduct() {
  const [myProducts, setMyProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      const userIdRaw = localStorage.getItem('userId');
      if (!userIdRaw) {
        console.error('No userId in localStorage');
        setLoading(false);
        return;
      }

      try {
        const userIdParsed = JSON.parse(userIdRaw);
        const userId = userIdParsed?.V2E;

        if (!userId) {
          console.error('Invalid userId format');
          setLoading(false);
          return;
        }

        const res = await getMyPurchasedProducts(userId) as { data: Product[] };
        setMyProducts(res?.data || []);
        console.log(res?.data,"res==========")
      } catch (error) {
        console.error('Failed to fetch products:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);
 


  return (
    <div className=""    
    >
      <div className='m-auto' style={{maxWidth: '1100px', width: '95%'}}>
        {/* Add the new badge here */}        
        {(!loading && myProducts.length > 0) && (
          <h3 className='text-white text-center my-4'>My collectibles</h3>
        )}
        {loading ? (
          <div className="d-flex align-items-center justify-content-center mt-3">
            <span
              className="loading"
              style={{
                color: 'white',
                wordBreak: 'break-all',
                paddingTop: '3px',
                paddingLeft: '10px',
                fontSize: '1.6em',
              }}
            >
              Loading...
            </span>
          </div>
        ) : myProducts.length > 0 ? (
          <ProductsGrid>
            {myProducts?.map((buyProduct: any, index) => (
              <ProductCard key={buyProduct.productId + '-' + index} style={{position: 'relative'}}>
                <VCoinStar>
                  <div className="vcoin-pill">
                    <span className="vcoin-content">
                      <span className="vcoin-amount">{buyProduct?.vCoin.toLocaleString() ?? 0}</span>
                      <span className="vcoin-label">Vcoins</span>
                    </span>
                  </div>
                  <span className="gold-star">
                    <img src={StartVcoin} alt="StartVcoin" style={{ width: '48px', height: '48px' }} />
                  </span>
                </VCoinStar>
                <ProductImageWrapper>
                  <ProductImage
                    src={buyProduct?.image_link}
                    alt={buyProduct?.productName || 'Collectible image'}
                  />
                  <div className='mt-3'>
                  <ProductName>{buyProduct?.productName}</ProductName>                    
                  {/* <ProductDetail>Serial No : <span>{buyProduct?.productSerialNumber}</span></ProductDetail> */}
                  <ProductDetail>Rarity : <span>{buyProduct?.rarity}</span></ProductDetail>                  
                  <ProductDetail>Serial No : <span>{`${buyProduct.productSerialNumber.slice(0, 14)}...`}</span></ProductDetail>
                  </div>
                </ProductImageWrapper>               
              </ProductCard>
            ))}
          </ProductsGrid>
        ) : (
          <div className="d-flex align-items-center justify-content-center mt-3">
            <p className="text-center text-white">No collectible found</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default MyProduct;
